import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PdfOptions {
  includeFinalScore: boolean;
  includeQuestionScores: boolean;
  excludedQuestions: number[];
}

@Component({
  selector: 'app-pdf-options-dialog',
  template: `
    <h2 mat-dialog-title>PDF Report Options</h2>
    <mat-dialog-content style="min-width: 700px;">
      <div style="margin-bottom: 20px;">
        <mat-checkbox [(ngModel)]="options.includeFinalScore">
          Include Final Score
        </mat-checkbox>
      </div>

      <div style="margin-bottom: 20px;">
        <mat-checkbox [(ngModel)]="options.includeQuestionScores">
          Include Individual Question Scores
        </mat-checkbox>
      </div>

      <div style="margin-bottom: 20px;">
        <h4>Exclude Questions from Report:</h4>
        <div *ngFor="let question of data.questions; let i = index" style="margin-left: 20px; margin-bottom: 10px;">
          <mat-checkbox 
            [checked]="isQuestionExcluded(i)"
            (change)="toggleQuestionExclusion(i)"
            style="align-items: flex-start;">
            <span style="display: inline-block; white-space: normal; word-wrap: break-word; max-width: 600px; line-height: 1.4;">
              <strong>Question {{ i + 1 }}:</strong> {{ question.question | slice:0:150 }}{{ question.question.length > 150 ? '...' : '' }}
            </span>
          </mat-checkbox>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onDownload()">
        <mat-icon>picture_as_pdf</mat-icon>
        Download PDF
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      max-height: 70vh;
      overflow-y: auto;
      padding: 20px 24px;
    }
    h4 {
      color: #369;
      margin-bottom: 15px;
      font-weight: 600;
    }
    ::ng-deep .mat-checkbox-label {
      white-space: normal !important;
    }
  `]
})
export class PdfOptionsDialogComponent {
  options: PdfOptions = {
    includeFinalScore: true,
    includeQuestionScores: true,
    excludedQuestions: []
  };

  constructor(
    public dialogRef: MatDialogRef<PdfOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { questions: any[] }
  ) {}

  isQuestionExcluded(index: number): boolean {
    return this.options.excludedQuestions.includes(index);
  }

  toggleQuestionExclusion(index: number): void {
    const idx = this.options.excludedQuestions.indexOf(index);
    if (idx > -1) {
      this.options.excludedQuestions.splice(idx, 1);
    } else {
      this.options.excludedQuestions.push(index);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onDownload(): void {
    this.dialogRef.close(this.options);
  }
}
